import { getFrontendEnv } from '@bm-js/atlascloud-shared'

/** APP_ENV is exposed to client code via envPrefix in vite.config.ts */
export const env = getFrontendEnv(import.meta.env.APP_ENV)
